/*共通ヘッダー*/
import React, { useState } from 'react';
import ModalTemplate from '../molecules/ModalTemplate';
import { editModalBody } from '../EditModal';
import { user_role_id } from '../Const';
var TopArea = function (_a) {
    var is_staff = _a.is_staff, changed = _a.changed, t = _a.t, handleClick = _a.handleClick, is_operation_with_stl = _a.is_operation_with_stl, clickReceptionHistory = _a.clickReceptionHistory, login_user_role_id = _a.login_user_role_id;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    /**
     * 戻る押下
     */
    var handleClickBack = function () {
        changed ? setOpen(true) : handleDialogYes();
    };
    /**
     * はい押下
     */
    var handleDialogYes = function () {
        setOpen(false);
        window.location.href = is_staff
            ? "" + location.origin + process.env.MIX_MOCK_URL + "/staff/list" + location.search
            : "" + location.origin + process.env.MIX_MOCK_URL + "/mypage/list";
    };
    /**
     * いいえ押下
     */
    var handleDialogNo = function () {
        setOpen(false);
    };
    /**
     * 更新履歴の表示
     * @returns 標示:true 非表示:false
     */
    var isVisibleReceptionHistory = function () {
        return (login_user_role_id === user_role_id.operation_without_personal_info ||
            login_user_role_id === user_role_id.operation_with_personal_info);
    };
    return (React.createElement(React.Fragment, null,
        isVisibleReceptionHistory() && (React.createElement("div", { className: "top-area mx-auto px-0 col-11 col-xs-10 col-lg-9" },
            React.createElement("div", { className: "top-area-continer right" },
                React.createElement("a", { className: "btn btn-main-color btn-xl", onClick: function (event) { return clickReceptionHistory(event, 'history'); } }, t('更新履歴'))))),
        React.createElement("div", { className: "top-area mx-auto px-0 col-11 col-xs-10 col-lg-9" },
            is_operation_with_stl && (React.createElement("div", { className: "top-area-continer left" },
                React.createElement("a", { className: "btn btn-main-color btn-xl", onClick: handleClick }, t('備考登録')))),
            React.createElement("div", { className: "top-area-continer right" },
                React.createElement("a", { className: "btn btn-main-color btn-xl", onClick: handleClickBack }, t('戻る'))),
            React.createElement(ModalTemplate, { show: open, title: t('確認'), body: editModalBody(t('案件一覧に戻ってよろしいですか？') + "\n" + t('（入力途中で一時保存をされていない場合は、入力内容は破棄されます。）')), ClickCallBackNo: handleDialogNo, ClickCallBackYes: handleDialogYes, t: t }))));
};
export default TopArea;
